import React,{useEffect,useState}  from 'react'
import { connect } from 'react-redux';
import Helper from '../functions/Helper.js';
import {HashLink as Link} from 'react-router-hash-link';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions/Actions.js';
import Table from 'react-bootstrap/Table';
import styled from "@emotion/styled";
import {jsx} from '@emotion/react'


import { Helmet } from "react-helmet";

const liStyle={marginLeft:50,marginBottom:5,fontWeight:500};

const MainContent=styled.div((props)=>{
  return(

    {
      paddingBottom:100,
      "@media (min-width:992px)":{
        paddingBottom:0,
        flex:"0 0 70%",maxWidth:"70%",
        paddingRight:50,
        borderRight:"1px solid #eeeeee"

      },
    }
  )
});

const Sidebar=styled.div((props)=>{
  return(
    {
      "@media (min-width:992px)":{
        flex:"0 0 30%",
        maxWidth:"30%",
        paddingLeft:30,
      },
    }
  )
});

const Container=styled.div((props)=>{
  return(
    { paddingBottom:100,
      "@media (min-width:992px)":{display:"flex"},
    }
  )
});




function HowTo(props){
  let [critics,setCritics]=useState([]);
  let [allShoesStats,setAllShoesStats]=useState([]);

  useEffect(()=>{
      fetch(__server__ + '/API/pub/critics', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        setCritics(data)
        }
      )

      fetch(__server__ + '/API/pub/filter?required_data=stats', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        setAllShoesStats(data)
        }
      )

  },[]);
  let shoe_amount=allShoesStats?.stats?.count ?? "";
  let review_amount=allShoesStats?.stats?.review_amount ??"";



  return(
    <Container>
      <Helmet>
        <title>How does the Shoe Review Database Work?</title>
        <meta property="og:title" content={"How does the Shoe Review Database Work?"}/>
        <meta name="description" content={"Explanation of the shoe database and how I gather and rate reviews." }/>
      </Helmet>
      <MainContent>
        <div style={{fontSize:18}}>
          <h1 style={{marginBottom:20}}>Helping you find the best shoes ever!</h1>
          <p>
            The goal of <Link to="/shoe-reviews/">thehoopsgeek.com</Link> is to help serious basketball players find the equipment that takes their game to the next level.
          </p>
          <p>It does so by:</p>
          <ul>
            <li style={liStyle}>
              Showing you all the latest performance shoe releases
            </li>
            <li style={liStyle}>
              Helping you to identify the best-performing sneakers
            </li>
            <li style={liStyle}>
              Finding shoes that fit you playing style and the shape of your feet
            </li>
            <li style={liStyle}>
              Comparing prices among most popular online sneaker stores so that you don't pay more than you need to
            </li>
          </ul>

          <h2 style={{marginTop:60}}>
            How does it work?
          </h2>
          <p>
            There are a lot of web sites out there that talk about the latest basketball shoe releases and publish super helpful shoe reviews.
            Every piece of information you need to make an informed buying decision is already out there – it’s just not very well organized!
          </p>
          <p>
            The goal of <Link style={{fontWeight:700}} to="/shoe-reviews">thehoopsgeek.com</Link> is not to add even more information, but to aggregate the info that is out there and make it sortable and easy to filter.
          </p>

          <h2 style={{marginTop:60}}>
            Colllecting all the data
          </h2>
          <p>
            The following information is collected about every single sneaker in the database:
          </p>
          <ul style={{marginLeft:20,marginTop:20}}>
            <li style={{marginLeft:20}}>
              ​Name and Brand
            </li>
            <li style={{marginLeft:20}}>
              Is it a low top, mid top or high top?
            </li>
            <li style={{marginLeft:20}}>
              Retail Price
            </li>
            <li style={{marginLeft:20}}>
              Prices from most pouluar online sneaker stores (updated very 6 hours)
            </li>
            <li style={{marginLeft:20}}>
              The release date
            </li>
            <li style={{marginLeft:20}}>
              A list of the available colorways
            </li>
            <li style={{marginLeft:20}}>
              Expert opinion on traction, cushion, fit, support, materials, outdoor usage, width and size
            </li>
          </ul>

          <h2 style={{marginTop:60}}>
            Which reviews are used for the aggregator?
          </h2>
          <p>
            The scores for cushion, traction, material, support, fit as well as overall rating are generated by reading all reviews published for a particular shoe and taking the average score out of all these reviews.
            These are the criteria that are used to determine if a review is included or not:
          </p>
          <ul>
            <li style={{marginLeft:20}}>
              The reviewer has to have played a significant amount in the shoes. No previews or overviews are used.
            </li>
            <li style={{marginLeft:20}}>
              The review has to be honest and unbiased.
            </li>
            <li style={{marginLeft:20}}>
              The reviewer needs to review shoes frequently.
            </li>
          </ul>
          <p>
            Here is a list of all critics:
          </p>
          <Table striped size="sm">
            <thead>
              <tr>
                <th>Critic</th>
                <th style={{textAlign:"right"}}># of reviews</th>
                <th style={{textAlign:"right"}}>avg. rating</th>
              </tr>
            </thead>
            <tbody>
              {critics.map((critic)=>{
                return(
                  <tr key={critic.critic_id} style={{fontSize:16}}>
                    <td>
                      <a style={{fontWeight:600}} href={critic.homepage}>
                        {critic.name}
                      </a>
                    </td>
                    <td style={{textAlign:"right"}}>
                      {critic.count}
                    </td>
                    <td style={{fontWeight:600,textAlign:"right",color:Helper.get_color(Number(critic.avg).toFixed(1),"text")}}>
                      {Number(critic.avg).toFixed(1)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <h2 style={{marginTop:60}}>How are reviews collected?</h2>
          <h3 style={{marginTop:30}}>Scores and quotes:</h3>
          <p>
            Every review is read or watched to gather quotes and scores. If the reviewer uses a 1-10 scale, then the score is just recorded as is.
            If the reviewer uses a different scale, the score is transformed to a 1-10 scale to provide consistency across the different reviews.
            If no scores are given out at all, a score will be assigned depending on how enthusiastic the author sounds.
          </p>
          <p>
            This is the scale that is used for reviews where the critic doesn't assign a specific score:
          </p>
          <p>
            <b>Explanation of Ratings:</b>
          </p>
          {[
            {rating:10,description:"Amazing"},
            {rating:9,description:"Great"},
            {rating:8,description:"Good"},
            {rating:7,description:"Satisfying"},
            {rating:6,description:"Below Average"},
            {rating:5,description:"Bad"}
          ].map((item,index)=>{
            return(
              <div key={index} style={{display:"flex",marginBottom:5,flexDirection:"row",}}>
                <div style={{backgroundColor:Helper.get_color(item.rating,"bg"),color:"#fff",fontWeight:700,lineHeight:"38px",width:50,height:38,textAlign:"center",fontSize: 17,marginRight:10}}>
                  {item.rating}
                </div>
                <div style={{display:"flex",alignItems:"center"}}>
                  {item.description}
                </div>
              </div>

            );
          })}

          <h3 style={{marginTop:60}}>
            Outdoor, width and length
          </h3>
          <p>
            When reviewers mention whether a shoe works outdoors, this information will be recorded as one of these 3 choices: Good, fair or bad.
          </p>
          <p>
            Length of shoes will be recorded as either “runs small”, “runs slightly small”, “true to size”, “runs slightly large”, “runs large”.
          </p>
          <p>
            Width of shoes is registered as one of these choices: “very narrow”, “slightly narrow”, “regular”, “slightly wide”, “very wide”.
          </p>

          <h3 style={{marginTop:60}}>Prices are updated frequently</h3>
          <p>
            Prices from the different shoe stores displayed on the page are updated every 6 hours so you can always find the best deal available.
          </p>



        </div>
      </MainContent>
      <Sidebar>
        <div className="textwidget custom-html-widget">
          <div className="widget_profile_image_wrapper">
            <img className="widget_profile_image" alt="profile" src={__cdn__+"/wp-content/uploads/2018/08/profil_picture.png"} scale="0"/>
          </div>
          <div className="widget_profile_body">
            <div className="widget_profile_hi">
              Hi, I'm Andy
            </div>
          </div>
          <div>
            <p style={{textAlign:"justify"}}>And I have something to confess: <b>I'm crazy about basketball!</b></p>
            <div style={{marginBottom:15}}>
              Crazy enough to spend days reading or watching <b>{review_amount} basketball shoe reviews</b> and summarizing them so that you can find your perfect pair of basketball shoes more easily.
            </div>
            <div style={{marginBottom:15}}>
              So far, this database includes <b>{shoe_amount} performance basketball shoes</b>, but I always try to keep it up to date and add new shoes as soon as I find enough reviews.
            </div>
            <div style={{marginBottom:15}}>
              If you want to help me out, you can do so by buying your shoes from the stores I link to. For every purchase I refer, I receive a small comission at no additional cost to you!
            </div>
            <div>Any questions or suggestions? <a style={{fontWeight:700}} href="mailto:andy@thehoopsgeek.com">Let me know!</a></div>
          </div>
        </div>
      </Sidebar>
    </Container>
  )
}


export default connect(state => ({ ...state.data}), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(HowTo);
